import Dashboard from './dashboard';
import Users from './users';
import Heinz from './heinz';

export default {
	Dashboard,
	Users,
	Heinz
}
